import Loader from '@/components/molecules/Loader';
import { useGetBestQuestionMobileCardsQuery } from '@/hooks/qna/mobile/qna.gql.impl';
import { qnaBestQuestionsService } from '@/services/qna/mobile';
import { ROUTES } from '@/types/common';
import { getPageName, mobileLogger } from '@/utils/logger';
import Link from 'next/link';
import { useRouter } from 'next/router';
import React from 'react';

const BestQuestions = () => {
  const router = useRouter();
  const { data: bestQuestionsData } = useGetBestQuestionMobileCardsQuery(
    {},
    {
      select: (data) => qnaBestQuestionsService(data),
    }
  );

  const onClickLinkLog = () => {
    mobileLogger({
      logger: {
        eventName: 'post_item_click',
        pageName: getPageName(router),
        payload: {
          platform: 'web',
        },
      },
    });
  };

  return (
    <div className='mt-[32px] w-full'>
      <div className='typography-ui-17sb mb-[4px] p-0 pl-[12px] text-gray-700'>실시간 상담 베스트</div>
      {bestQuestionsData?.bestQuestionCards ? (
        <ul className='w-full'>
          {bestQuestionsData?.bestQuestionCards.map((question) => (
            <li
              key={`best-question-${question.question.questionPid}`}
              role='button'
              onClick={onClickLinkLog}
              className='w-full rounded-[8px] hover:bg-gray-30 active:bg-gray-50'
            >
              <Link href={`${ROUTES.QNA.DETAIL.path}/${question.question.questionPid}`}>
                <a
                  href={`${ROUTES.QNA.DETAIL.path}/${question.question.questionPid}`}
                  className='typography-ui-15m flex min-w-0 items-center text-ellipsis whitespace-nowrap p-[12px] text-gray-600'
                >
                  <div className='typography-ui-17m mr-[12px] text-gray-200'>Q</div>
                  <p className='overflow-hidden text-ellipsis whitespace-nowrap'>{question.question.title}</p>
                </a>
              </Link>
            </li>
          ))}
        </ul>
      ) : (
        <Loader />
      )}
    </div>
  );
};

export default BestQuestions;
